if (typeof so == 'undefined') {
    var so = {};
}

so.wollondillycouncil = {
    init: function () {
        so.wollondillycouncil.mmenuInit();
        so.wollondillycouncil.navSearchToggle();
        so.wollondillycouncil.megaMenus();
        so.wollondillycouncil.switchFAQChevrons();
        so.wollondillycouncil.showHideAllFAQ();
        so.wollondillycouncil.mediaCenter();
        so.wollondillycouncil.emitGTMevent();
        so.wollondillycouncil.feedbackWidget();
        $('.fancybox').fancybox({
            'padding': 0,
            'transitionIn': 'fade',
            'transitionOut': 'fade',
            'titlePosition': 'over-wrap',
            'titleFormat': function (title, currentArray, currentIndex, currentOpts) {
                return '<span id="fancybox-title-over">Image ' + (currentIndex + 1) + ' / ' + currentArray.length + ' ' + title + '</span>';
            },
            overlayShow: true,
            overlayOpacity: 0.9
        });
        so.wollondillycouncil.globalHelpers();
        //so.wollondillycouncil.hideAnimalCalcButton();
    },
    globalHelpers: function () {
        // avoid SS malarkey with js triggers
        $('.no-ss[href]').each(function () {
            if ($(this).attr('href') != '') {
                var link = $(this).attr('href').split('#')[1];
                $(this).attr('href', '#' + link);
            }
        });
        $('[data-href]').addClass('jslink').on('click', function (e) {
            var target = $(this).data('href');
            window.location.href = target;
        });
        $('[data-gtm]').on('click', function (e) {
            var target = $(this).data('gtm');
            if (window.dataLayer) {
                window.dataLayer.push({'event': target});
            }
        });
        $('#content a, .content a').each(function () {
            // skip if this is an image link
            if ($(this).children('img').length === 0) {
                // append size if it is recorded
                if ($(this).data('size')) {
                    $(this).append(' <span class="file-size">(' + $(this).data('size') + ')</span>');
                }
                // open in new tab
                if ($(this).attr('target')) {
                    $(this).attr('title', 'Opens in a new window').append(' <span class="fa fa-external-link-square file-size  small" title="Opens in a new window"></span>');
                }
            }

        });
    },
    councillorsPage: function () {
        var maxHeight = 0;
        $('.councillor-summary').each(function () {
            maxHeight = ($(this).height() > maxHeight) ? $(this).height() : maxHeight;
        });
        $('.councillor-summary').height(maxHeight);
    },
    showHideAllFAQ: function () {
        $('.faq-holder .faq-showall').on('click', function () {
            $('#accordion .faq-detail').collapse('show');
        });
        $('.faq-holder .faq-hideall').on('click', function () {
            $('#accordion .faq-detail').collapse('hide');
        });
    },
    switchFAQChevrons: function () {
        $('[data-toggle=collapse]').click(function (event) {
            var target = $(this).attr('data-target');
            if (target) {
                target = '#' + target.split('#')[1];
            } else {
                target = '#' + $(this).attr('data-target');
            }
            var targetel = $(target);
            var others = "[data-target='" + target + "']";
            others = $(others);

            $(others).each(function () {

                var button = $(this).find('span.open-indicator');
                if (typeof button != 'undefined') {
                    if (button.hasClass('status-up')) {
                        button.removeClass('status-up');
                        button.addClass('status-down');
                    } else {
                        button.removeClass('status-down');
                        button.addClass('status-up');
                    }
                }
            });
        });
    },
    searchToggle: function (direction) {
        if (direction == 'open') {
            $('.search').addClass('open');
            $('.search .opener').attr('tabindex', '-1');
        } else {
            $('.search').removeClass('open');
            $('.search .opener').removeAttr('tabindex');
        }
    },
    navSearchToggle: function () {
        $(".header-search-trigger-desktop, .search-skip").click(function () {
            $(".logorow").toggleClass("logorow-search-open");

            if (!$(this).hasClass("open")) {
                setTimeout(function () {
                    $('#SearchForm_SearchForm_Search').focus();
                }, 100);
            }
        });
        // $('.search .search-icon').on('click', function () {
        //     so.wollondillycouncil.searchToggle('open');
        // });
        // $('.search .closer').on('click', function (e) {
        //     e.preventDefault();
        //     so.wollondillycouncil.searchToggle('close');
        //     return false;
        // });
        // $('.search a.opener').on('focus', function () {
        //     if (!$('.search').hasClass('open')) {
        //         so.wollondillycouncil.searchToggle('open');
        //         setTimeout(function(){ $('#SearchForm_SearchForm_Search').focus(); }, 1000);
        //     }
        // });
        // $('.search .closer').on('focus', function () {
        //     if ($('.search').hasClass('open')) {
        //         so.wollondillycouncil.searchToggle('close');
        //     }
        // });
        // $('#SearchForm_SearchForm_Search').on('focus', function () {
        //     so.wollondillycouncil.searchToggle('open');
        // });
        // $('.search-skip').on('click', function() {
        //     so.wollondillycouncil.searchToggle('open');
        //     setTimeout(function(){ $('#SearchForm_SearchForm_Search').focus(); }, 1000);
        // });
    },
    megaMenus: function () {
        $(".header-menu-trigger-desktop:not(.navbar-toggle)").click(function () {
            $(".mega-menu").toggleClass('open');
            $(".logorow").toggleClass('logorow-fixed');
            $('body').toggleClass('no-overflow');
            if ($('.alerts-bar').length) {
                var scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                var scrollto = $('.alerts-bar').position().top + $('.alerts-bar').offset().top + $('.alerts-bar').outerHeight(true);
                if (scrolltop === 0) {
                    $("html, body").animate({scrollTop: scrollto + "px"}, 0);
                }
            }
        });

        $(".header-trigger:not(.navbar-toggle)").click(function () {
            $(this).toggleClass("open");
        });


        // $('.nav-item').each(function () {
        //     $(this).on('mouseenter', function () {
        //         $(this).addClass('open');
        //     }).on('mouseleave', function () {
        //         $(this).removeClass('open');
        //     }).on('blur', function () {
        //         $(this).removeClass('open');
        //     });
        //     $('.nav-item > a').on('focus', function () {
        //         $('.nav-item').removeClass('open');
        //         so.wollondillycouncil.searchToggle('close');
        //         $(this).parent('.nav-item').addClass('open');
        //     });
        // });
        $('.search-icon a').on('focus', function () {
            $('.nav-item').removeClass('open');
        });
        $(".mega-menu").scroll(function () {
            var containerHeight = $(".mega-menu-column-container").height();
            var scrollButtonOffset = $(".mega-menu-scroll")[0].offsetTop;

            if ((scrollButtonOffset + $(".mega-menu-scroll").height()) > containerHeight) {
                $(".mega-menu-scroll").addClass('mega-menu-scroll-hidden');
            } else {
                $(".mega-menu-scroll").removeClass('mega-menu-scroll-hidden');
            }
        });
        $(".mega-menu-scroll-trigger").click(function (e) {
            e.preventDefault();
            var containerHeight = $(".mega-menu-column-container").outerHeight() + $(".mega-menu-scroll").height();
            var menuViewportHeight = $(".mega-menu").height();
            var amountToScroll = 0;
            var offsetTop = $(".mega-menu").scrollTop();
            var containerLeftToScroll = containerHeight - (menuViewportHeight + offsetTop);

            if (containerHeight <= menuViewportHeight) {
                return;
            }

            if (containerLeftToScroll < menuViewportHeight) {
                amountToScroll = containerLeftToScroll;
            } else {
                amountToScroll = menuViewportHeight;
            }

            $(".mega-menu").animate({
                scrollTop: offsetTop + amountToScroll
            }, 1000);
        });
    },
    mediaCenter: function () {
        // setup

        $('.media-channel').each(function () {
            var scrollWidth = ($(this).width());
            var scrollInner = ($(this).find('.scroller').width());
            if (scrollWidth >= scrollInner) {
                $(this).addClass('no-scroll-open');
            }
        });
        $('.left-scroller').not('.no-open').on('click', function (event) {
            event.preventDefault();
            var scrollWidth = ($(this).parents('.media-channel').width()) / 2;
            var ScrollLeft = $(this).parents('.scroll-container').scrollLeft();
            var setLeft = parseInt(ScrollLeft) - parseInt(scrollWidth);
            if (setLeft < 0) {
                setLeft = 0;
            }
            $(this).parents('.scroll-container').animate({
                scrollLeft: setLeft
            }, 'fast');
        });
        $('.right-scroller').not('.no-open').on('click', function (event) {
            event.preventDefault();
            var scrollWidth = ($(this).parents('.media-channel').width()) / 2;
            var ScrollLeft = $(this).parents('.scroll-container').scrollLeft();
            var setLeft = parseInt(ScrollLeft) + parseInt(scrollWidth);
            if (setLeft < 0) {
                setLeft = 0;
            }
            $(this).parents('.scroll-container').animate({
                scrollLeft: setLeft
            }, 'fast');
        });
    },
    // subnavPull: function () {
    //     $('.submenu').each(function () {
    //         var dink = $(this).children().children('ul').children('li').not('.hasChild');
    //         if (dink.length > 0 ) {
    //             $(this).find('.submenu-right').removeClass('col-sm-12').addClass('col-sm-9').before('<div class="col-sm-3 submenu-left"><ul>').find('.col-sm-3').removeClass('col-sm-3').addClass('col-sm-4');
    //             dink.removeClass('col-sm-4');
    //             dink.appendTo($(this).children('.submenu-left').children('ul'));
    //         }
    //         $(this).find('.submenu-right .col-sm-4:nth-child(3n-2)').css({'clear':'left'});
    //         $(this).find('.submenu-right .col-sm-3:nth-child(4n-3)').css({'clear':'left'});
    //     });
    // },
    mmenuInit: function () {
        var link = $('.navbar-toggle').attr('href').split('#')[1];
        $('.navbar-toggle').attr('href', '#' + link);
        $('#mobile-nav-strip').mmenu({
            offCanvas: {
                position: "right",
                page: {
                    selector: ".mmenu-reference"
                }
            }
        });
    },
    emitGTMevent: function (eventString) {
        if (window.dataLayer) {
            window.dataLayer.push({'event': eventString});
        }
    },
    feedbackWidget: function () {

        var checked = $('[id*=Form_PageFeedbackForm_IsUseful_]:checked').parent();
        if (checked.length) {
            checked.addClass('checked');
            //$('#feedback-group').addClass('show');
            //$('#Form_PageFeedbackForm_action_submitPageFeedbackForm').addClass('show')
        } else {
            //$('#feedback-group').removeClass('show');
            //$('#Form_PageFeedbackForm_action_submitPageFeedbackForm').removeClass('show');
        }

        // // hide Submit Feedback button
        

        $('[id*=Form_PageFeedbackForm_IsUseful_]').on('change', function () {
            checked.removeClass('checked');
            checked = $('[id*=Form_PageFeedbackForm_IsUseful_]:checked').parent();
            if (checked.length) {
                checked.addClass('checked');
                $('#feedback-group').addClass('show');
                $('#Form_PageFeedbackForm_action_submitPageFeedbackForm').addClass('show');
            }

            var value = $('[id*=Form_PageFeedbackForm_IsUseful_]:checked').val();
            $.ajax({
                method: 'GET',
                data: {'rate': value},
                url: feedbacklink
            });
        });

        $('.feedback-expander').on('keypress, click', function () {

            $('#Form_PageFeedbackForm_action_submitPageFeedbackForm').toggle();  // show/hide
            // chevron toggler
            $('.feedback-expander .menu-chevron').toggleClass('chevron-up');
        });

        //additional form fixup for styling overrides
        $('#subscribe-group nav').removeClass('Actions');
    },
    // hideAnimalCalcButton: function() {
    //     var submitButton = document.getElementById('UserForm_Form_4149_action_process');
    //     if (submitButton.length) {
    //         submitButton.remove();
    //     }
    // }
};

$(document).ready(function () {
    so.wollondillycouncil.init();
});


//$(window).load(function () {
//so.wollondillycouncil.councillorsPage();
//});
